import Modal from "./Modal";
import FileExplorer from "../FileExplorer/FileExplorer";
import { useState } from "react";

export default function ProjectModal({ files, data, callback, closeModal, onSubmit, onSubmitFolder, onCancel }) {
    const [dir, setDir] = useState("");

    function selectDir(dir) {
        setDir(dir);
        callback({"ProjectName2":dir.split("/").at(-2)})
    }

    return (
        <Modal closeCallback={closeModal}>
            <div>
                <p>Add custom project</p>
                <label htmlFor="name">Name:</label>
                <input type="text" className="controls__input" id="name" name="projectName" value={data.ProjectName || ""} onChange={(e)=>{callback({"ProjectName":e.target.value})}} />
                <br/>
                <label htmlFor="desc">Description:</label>
                <textarea type="text" className="controls__textarea" id="desc" name="projectDesc" value={data.ProjectDesc || ""} onChange={(e)=>{callback({"ProjectDesc":e.target.value})}} ></textarea>
                <br/>
                <label htmlFor="date">Date<span style={{"color":"darkred","fontWeight":"bold"}}>*</span>:</label>
                <input type="date" name="date" id="date" value={data.Date || ""} onChange={(e)=>{callback({"Date":e.target.value})}} />
                <br/>
                <button className="modal__button" onClick={onSubmit} disabled={data.Date === undefined}>Submit</button>
                <br/><br/>
                <p>Or: add from folder</p>
                

                <FileExplorer
                    files={files}
                    callback={selectDir}
                    selectFolder
                />
                <label htmlFor="name2">Name:</label>
                <input type="text" className="controls__input" id="name2" name="projectName" value={data.ProjectName2 || ""} onChange={(e)=>{callback({"ProjectName2":e.target.value})}} />
                <br/>
                <label htmlFor="desc2">Description:</label>
                <textarea type="text" className="controls__textarea" id="desc2" name="projectDesc" value={data.ProjectDesc2 || ""} onChange={(e)=>{callback({"ProjectDesc2":e.target.value})}} ></textarea>
                <br/>
                <label htmlFor="date2">Date<span style={{"color":"darkred","fontWeight":"bold"}}>*</span>:</label>
                <input type="date" name="date2" id="date2" value={data.Date2 || ""} onChange={(e)=>{callback({"Date2":e.target.value})}} />
                <br/>
                <button className="modal__button" onClick={()=>{onSubmitFolder(dir)}} disabled={dir === "" || data.Date2 === undefined}>Submit</button>
            </div>
            </Modal>
    )
}